<ion-header>
    <ion-toolbar color="primary">
        <ion-title> Detalhes da Sua Meta</ion-title>
        <ion-buttons slot="end">
            <ion-button fill="clear" (click)="close()">
                <ion-icon slot="icon-only" name="close"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
    <ion-card>
        <ion-card-header>
            <ion-card-title>{{ title }}</ion-card-title>
        </ion-card-header>
        <ion-card-content>
            <p class="description-text">{{ description }}</p>
        </ion-card-content>
    </ion-card>
</ion-content>

<ion-footer>
    <ion-toolbar>
        <ion-button expand="block" color="primary" (click)="close()">Fechar</ion-button>
    </ion-toolbar>
</ion-footer>